import { podcastTypes } from '@/utils/config/showOptions';
import {
    isDimensions,
    isFile,
    isFilled,
    isIn,
    isMax,
    isUrl,
} from '@/utils/form/validationRules';
import htmlToText from '@/utils/htmlToText';

/**
 * Performs base validation of Show Feed URL.
 *
 * @param   {string}       feedUrl  Show Feed URL.
 * @returns {string|null}           Validation result.
 */
export const validateFeedUrl = (feedUrl) => {
    if (! isFilled(feedUrl)) {
        return 'Please provide RSS URL.';
    }

    if (! isUrl(feedUrl)) {
        return 'Please provide valid RSS URL.';
    }

    return null;
};

/**
 * Performs base validation of Show Title.
 *
 * @param   {string}          title  Show Title.
 * @returns {string|null}            Validation result.
 */
export const validateTitle = (title) => {
    if (! isFilled(title)) {
        return 'Please provide the Podcast Name.';
    }

    return null;
};

/**
 * Performs base validation of Show Description.
 *
 * @param   {string}            description             Show Description.
 * @param   {object}            config                  Validation configuration.
 * @param   {number|undefined}  config.charactersLimit  Description characters limit.
 * @returns {string|null}                               Validation result.
 */
export const validateDescription = (description, { charactersLimit }) => {
    if (! isMax(htmlToText(description), charactersLimit)) {
        return 'Please change the Podcast Description.';
    }

    return null;
};

/**
 * Performs base validation of Show Artwork.
 *
 * @param   {File|null}    artwork                  Show Artwork.
 * @param   {object}       config                   Validation configuration.
 * @param   {string[]}     config.allowedMimeTypes  Artwork allowed MIME types.
 * @returns {string|null}                           Validation result.
 */
export const validateArtwork = async (artwork, { allowedMimeTypes }) => {
    if (! isFile(artwork)) {
        return null; // do not validate if is not file
    }

    if (! isIn(artwork.type, allowedMimeTypes)) {
        return 'Please select the Podcast Artwork in valid format.';
    }

    if (! await isDimensions(
        artwork,
        { minHeight: 1400, minWidth: 1400, maxHeight: 4000, maxWidth: 4000 }
    )) {
        return 'Please select the Podcast Artwork with correct size.';
    }

    if (! await isDimensions(artwork, { ratio: 1 / 1 })) {
        return 'Please select the Podcast Artwork which is square.';
    }

    return null;
};

/**
 * Performs base validation of Show Podcast Type.
 *
 * @param   {string}    type Show Podcast Type.
 * @returns {string|null}     Validation result.
 */
export const validatePodcastType = (type) => {
    if (! isFilled(type)) {
        return 'Please select the Podcast Type.';
    }

    if (! podcastTypes.map((podcastType) => podcastType.value).includes(type)) {
        return 'Please select other Podcast Type.';
    }

    return null;
};
